import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
<script src="https://www.gstatic.com/firebasejs/8.3.1/firebase-app.js"></script>
var firebaseConfig = {
  apiKey: "AIzaSyCDdj3szGd4XdivT0JjfybxjukU6hV17H4",
  authDomain: "fir-connect-e726b.firebaseapp.com",
  projectId: "fir-connect-e726b",
  storageBucket: "fir-connect-e726b.appspot.com",
  messagingSenderId: "35407786422",
  appId: "1:35407786422:web:e7af8bfee20691685f9117"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.firestore().settings({ timestampsInSnapshots: true });

  export default firebase;